<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-chip @click="back()" color="blueKonect" medium text class="pa-4 mb-2 white--text">Atras</v-chip>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Codigos QR del empleado: {{ this.vanOffline.item.nombre + " " + this.vanOffline.item.apellido_paterno + " " + this.vanOffline.item.apellido_materno }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <sbtn text="Agregar" :onClick="newUser" icon="mdi-plus" colorBtn="white" typeButton="text" :load="loading" :disabled="!isWriting" />
        </v-toolbar>
        <v-card-title style="display: flex; align-items: flex-end;">
          <v-text-field class="pl-5 mt-0" v-model="search" label="Buscar" single-line hide-details clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-btn :disabled="!isReading" small center outlined color="blueKonect" class="mx-2" elevation="0" @click="update()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="qrCodes"
            :loading="loading"
            loading-text="Cargando registros... Porfavor espere"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <infoBtn :icon="'mdi-download'" :text="'Descargar'" :actionColor="'blueKonect'" :data="item" :onClick="openQR" :permission="!isReading" />
              <infoBtn :icon="'mdi-trash-can'" :text="'Eliminar'" :actionColor="'red'" :data="item" :onClick="openRemove" :permission="!isRemoving" />
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogs.new" persistent scrollable max-width="900px">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="2">
            <v-toolbar-title>Nuevo codigo QR</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="!isWriting || loading" :disabled="!date || !date2 || state.length < 1" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="min-height: 150px; display: flex; align-items: center">
            <v-container>
              <v-row>
                <v-col cols="3" style="display: flex; align-items: flex-end">
                  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="date" dense label="Fecha de inicio" hide-details prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" :min="this.allowedDates" scrollable locale="es">
                      <v-spacer></v-spacer>
                      <v-btn text @click="modal = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(date)"> Aceptar </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="3" style="display: flex; align-items: flex-end">
                  <v-dialog ref="dialog2" v-model="modal2" :return-value.sync="date2" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="date2" dense label="Fecha fin" hide-details prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" :min="date" scrollable locale="es">
                      <v-spacer></v-spacer>
                      <v-btn text @click="modal2 = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog2.save(date2)"> Aceptar </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="state" :disabled="loading" multiple append-icon="mdi-chevron-down" item-value="idruta_externo" item-text="name" label="Rutas" :items="routes" hide-details>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @mousedown.prevent @click="toggle">
                        <v-list-item-action>
                          <v-icon :color="state.length > 0 ? 'indigo darken-4' : ''">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Todas las rutas </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption"> (+{{ state.length - 1 }} mas) </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.qr" persistent scrollable max-width="500px">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="2">
            <v-toolbar-title>Codigo QR</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="downloadQrCode()">
              Descargar
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="min-height: 150px; display: flex; align-items: center; justify-content: center">
            <vue-qr ref="qrCode" :text="qrCode.codigo" :logoScale="0.3" :logoMargin="10" :size="200" :dotScale="parseFloat(1)"></vue-qr>
          </v-card-text>
        </v-card>
      </v-dialog>
      <simpleDialog
        :active="dialogs.remove"
        :clickRemove="removeQR"
        :clickCancel="cancel"
        btnColor="red"
        removeMsg="¿Esta seguro que deseas eliminar el QR?"
        title="Eliminar QR"
        btnMsgRemove="Eliminar"
      />
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ msgError }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { simpleDialog, infoBtn, sbtn } from "@/components";
import errorList from "@/utils/errorsList";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default {
  name: "Clientes",
  components: {
    simpleDialog,
    sbtn,
    infoBtn,
    vueQr,
  },
  data: () => ({
    qrCode: "",
    urlLogo: require("@/assets/logo-app.png"),
    loading: false,
    success: false,
    msgSuccess: "",
    errorList,
    codeError: "",
    msgError: "",
    code: "",
    date: "",
    date2: "",
    allowedDates: "",
    allowedDates2: "",
    routes: [],
    state: [],
    modal: false,
    modal2: false,
    error: false,
    search: "",
    headers: [
      { text: "Número de nómina", align: "center", value: "numero_nomina", sortable: true },
      { text: "Nombre de Cliente", align: "center", value: "nombre_comercial", sortable: true },
      { text: "Fecha inicio del codigo", align: "center", value: "fecha_inicio", sortable: true },
      { text: "Fecha fin del codigo", align: "center", value: "fecha_fin", sortable: true },
      { text: "Rutas disponibles", align: "center", value: "rutas", sortable: true },
      { text: "Acciones", align: "center", value: "actions", sortable: false },
    ],
    qrCodes: [],
    clients: "",
    qrRemove: "",
    dialogs: {
      new: false,
      remove: false,
      qr: false,
    },
  }),
  activated() {
    if (this.isReading) {
      var dateFrom = moment(dateFrom).subtract(3, "months").format("YYYY-MM-DD");
      var dateFrom2 = moment(dateFrom2).subtract(2, "months").format("YYYY-MM-DD");
      this.allowedDates = dateFrom;
      this.allowedDates2 = dateFrom2;
      this.getRoutes();
      this.refresh();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    isRemoving: function () {
      return services.check(3, this.$route.path);
    },
    allRoutes() {
      return this.state.length === this.routes.length;
    },
    someRoutes() {
      return this.state.length > 0 && !this.allRoutes;
    },
    icon() {
      if (this.allRoutes) return "mdi-close-box";
      if (this.someRoutes) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    ...mapGetters("vanOffline", ["vanOffline"]),
  },
  methods: {
    ...mapActions("vanOffline", ["setComponent"]),
    update() {
      this.getRoutes();
      this.refresh();
    },
    async getRoutes() {
      try {
        this.loading = true;
        const clientsResponse = await this.axios.get(services.routes.clients);
        this.clients = _.uniqWith(clientsResponse.data.data, _.isEqual);

        const routesPromises = this.clients.map((client) => {
          return this.axios.get(services.routes.routesByClient + "/" + client.idcliente_externo);
        });

        const routesResponses = await Promise.all(routesPromises);
        this.routes = [];
        routesResponses.forEach((res) => {
          this.routes = this.routes.concat(res.data.data);
        });

        this.routes.forEach((route) => {
          route.name = route.nombre_ruta + " - " + route.tipo_servicio;
        });
        this.loading = false;
      } catch (error) {
        this.error = true;
        this.codeError = error.response.data.message;
      }
    },
    async refresh() {
      try {
        this.loading = true;
        this.qrCodes = [];
        const response = await this.axios.get(`${services.routes.vanOffline}/${this.vanOffline.item.idusuario_externo}`);
        const {
          detalle: {
            numero_nomina,
            detalle_usuario_offline: {
              cliente: { nombre_comercial },
              codigos_detalle_usuarios_offline,
            },
          },
        } = response.data.data;
        const cliente = { numero_nomina, nombre_comercial };
        this.qrCodes = codigos_detalle_usuarios_offline.map((codigo) => ({
          ...codigo,
          numero_nomina: cliente.numero_nomina,
          nombre_comercial: cliente.nombre_comercial,
          rutas: codigo.rutas_codigo_detalle_usuario_offline.map((ruta) => ` ${ruta.ruta.tipo_servicio} - ${ruta.ruta.nombre_ruta}`),
          fecha_inicio: moment(codigo.fecha_inicio).format("DD-MM-YYYY"),
          fecha_fin: moment(codigo.fecha_fin).format("DD-MM-YYYY"),
        }));
        this.qrCodes = this.qrCodes.filter((codigo) => codigo.fecha_borrado == null);

        this.loading = false;
      } catch (error) {
        this.error = true;
        this.msgError = error.response.data.message;
        this.codeError = error.response.data.code;
        this.loading = false;
      }
    },
    newUser() {
      this.dialogs.new = true;
    },
    save() {
      this.loading = true;
      let ruta = {
        fecha_inicio: moment(this.date + "T00:00:00+06:00"),
        fecha_fin: moment(this.date2 + "T23:59:59+06:00"),
        rutas_codigo_detalle_usuario_offline: [],
      };
      let idruta_externo = this.state;

      for (let i = 0; i < idruta_externo.length; i++) {
        ruta.rutas_codigo_detalle_usuario_offline.push({
          idruta_externo: idruta_externo[i],
        });
      }

      let usuario = {
        idusuario_externo: this.vanOffline.item.idusuario_externo,
        codigos_detalle_usuarios_offline: [ruta],
      };

      let data = [usuario];

      this.axios
        .post(services.routes.qr + "/generate/qr", { data })
        .then((res) => {
          this.cancel();
          this.refresh();
          this.success = true;
          this.msgSuccess = "Codigo QR creado correctamente";
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset();
      }
      if (this.$refs.formDetail) {
        this.$refs.formDetail.resetValidation();
      }
      this.dialogs.new = false;
      this.dialogs.remove = false;
      this.dialogs.qr = false;
      this.date = "";
      this.date2 = "";
      this.state = [];
    },
    openRemove(data) {
      this.qrRemove = data.idcodigo_detalle_usuario_offline_externo;
      this.dialogs.remove = true;
    },
    removeQR() {
      this.loading = true;
      let data = {
        data: {
          idcodigo_detalle_usuario_offline_externo: this.qrRemove,
        },
      };
      this.axios
        .delete(services.routes.qr + "/qr", { data: data })
        .then((res) => {
          this.cancel();
          this.refresh();
          this.success = true;
          this.msgSuccess = "Codigo QR eliminado correctamente";
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      this.setComponent({ component: "home" });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allRoutes) {
          this.allRoutesSelected = false;
          this.state = [];
        } else {
          this.allRoutesSelected = true;
          this.state = this.routes.map((obj) => obj.idruta_externo);
        }
      });
    },
    openQR(item) {
      this.qrCode = item;
      this.dialogs.qr = true;
    },
    downloadBase64File(base64Content, fileName) {
      try {
        const link = document.createElement("a");
        link.href = base64Content;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.error = true;
        this.msgError = "Error al descargar archivo: " + error;
        this.codeError = "GENERAL_ERROR";
      }
    },
    downloadQrCode() {
      try {
        // Obtener el elemento de la librería Vue QR
        const qrCodeElement = this.$refs.qrCode.$el;

        // Crear un canvas para dibujar el código QR
        const canvas = document.createElement("canvas");
        canvas.width = qrCodeElement.width;
        canvas.height = qrCodeElement.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(qrCodeElement, 0, 0);

        // Obtener la imagen en formato base64
        const qrCodeImage = canvas.toDataURL("image/png");

        // Descargar la imagen
        const fileName = this.qrCode.numero_nomina + "_" + this.qrCode.fecha_inicio + "_qr_code.png";
        this.downloadBase64File(qrCodeImage, fileName);
      } catch (error) {
        this.error = true;
        this.msgError = "Error al descargar código QR: " + error;
        this.codeError = "GENERAL_ERROR";
      }
    },
  },
};
</script>

<style scoped></style>
